import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CustomButton = styled(Button)`
  color: ${({ theme }) => theme.colors.white} !important;
  border-color: ${({ theme }) => theme.colors.green6} !important;
  background-color: ${({ theme }) => theme.colors.green6} !important;
  &:hover {
    color: ${({ theme }) => theme.colors.white} !important;
    border-color: ${({ theme }) => theme.colors.green6} !important;
    background-color: ${({ theme }) => theme.colors.green6} !important;
  }
  &:active,
  &:focus {
    color: ${({ theme }) => theme.colors.white} !important;
    border-color: ${({ theme }) => theme.colors.green6} !important;
    background-color: ${({ theme }) => theme.colors.green6} !important;
  }

  &.ant-btn:hover {
    color: ${({ theme }) => theme.colors.white} !important;
    border-color: ${({ theme }) => theme.colors.green6} !important;
    background-color: ${({ theme }) => theme.colors.green6} !important;
  }
`;

export const Text = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.black9};
`;
